"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EI_STATUSES = ['EI', 'EIRL'];
const getIsEi = (legalForm) => EI_STATUSES.includes(legalForm);
exports.default = getIsEi;
